import { call, put, takeEvery } from "redux-saga/effects"

import { GET_ROLES, ADD_NEW_ROLE, UPDATE_ROLE, DELETE_ROLE } from "./actionTypes";
import {
    getRolesSuccess,
    getRolesFail,
    addRoleSuccess,
    addRoleFail,

    updateRoleSuccess,
    updateRoleFail,
    
    deleteRoleSuccess,
    deleteRoleFail,
   
} from "./actions"

import {
    getRoles,
    addNewRole,
    updateRole,
    deleteRole,
   
} from "helpers/roles/roles_backend_helper";
import { toast } from "react-toastify";

function* fetchRoles() {
    try {
        const response = yield call(getRoles)
        yield put(getRolesSuccess(response))
    } catch (error) {
        yield put(getRolesFail(error))
    }
}

function* onAddNewRole({ payload: data }) {
    try {
        const response = yield call(addNewRole, data)
        yield put(addRoleSuccess(response))
        toast.success("Role  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addRoleFail(error))
        toast.error("Role  Added Failed", { autoClose: 2000 });
    }
}

function* onUpdateRole({ payload: role }) {
    try {
        console.log("ON UPDATE DAGA: ", role);
        const response = yield call(updateRole, role)
        yield put(updateRoleSuccess(response))
        toast.success("Role  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateRoleFail(error))
        toast.error("Role  Updated Failed", { autoClose: 2000 });
    }
}

function* onDeleteRole({ payload: data }) {

    try {
        const response = yield call(deleteRole, data)
        yield put(deleteRoleSuccess(response))
        toast.success("Role  Deleted Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(deleteRoleFail(error))
        toast.error("Role  Deleted Failed", { autoClose: 2000 });
    }
}


function* roleSaga() {
    yield takeEvery(GET_ROLES, fetchRoles)
    yield takeEvery(ADD_NEW_ROLE, onAddNewRole)
    yield takeEvery(UPDATE_ROLE, onUpdateRole)
    yield takeEvery(DELETE_ROLE, onDeleteRole)
}

export default roleSaga;